import React, { Component } from 'react';
import classnames from 'classnames';

import $ from 'jquery';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import Utils from '~/core/scripts/utils';
import LeafletTopojson from './leaflet.topojson';
import './leaflet.side-by-side';
import mapLabels from './labels';
import { disableMap, enableMap } from '~/core/scripts/map-components/utils';
import Icon from '~/core/scripts/components/Icon';

LeafletTopojson.init(L);

const getLabelsByZoom = function(params) {
  if (typeof params === 'undefined') {
    var params = {};
  }

  var zoom = params.zoom || 0,
    language = params.language || 'de',
    labels = [];

  for (var l in mapLabels) {
    var zooms = l.split('-');

    if (zoom >= parseInt(zooms[0]) && zoom <= parseInt(zooms[1])) {
      labels = mapLabels[l][language];
      break;
    }
  }

  return labels;
};

const updateZoomClass = (zoom, recentZoom) => {
  document.body.classList.remove(`zoom${recentZoom}`);
  document.body.classList.add(`zoom${zoom}`);
};

const mapConfig = {
  center: [52.5113602, 13.3994141],
  bounds: [[52.2157353,12.8153363], [52.8393962,14.0197683]],
  minZoom: 9,
  maxZoom: 17,
  accessToken:
    'pk.eyJ1IjoiYmVybGluZXJtb3JnZW5wb3N0IiwiYSI6IjVhZWJkYWU4Zjg4YTdkYWYwMGUzOTAzMTU4NzI3MDliIn0.WrzhdNN4v9RQ_PlscNfDvg',
  attribution: '1989: Senatsv. für Stadtentw. | 2019: Geoportal Berlin / OK Lab, Maptiler'
};

const removeCta = () => {
  document.querySelector('.map-comp-wrapper .calltoaction').style.display = 'none';
};

class Map extends Component {
  state = {
    isMapActive: false
  };

  constructor(props) {
    super(props);

    this.map = null;
    this.topoLayer = new L.TopoJSON();
    this.borderLayer = new L.TopoJSON();
    this.mapConfig = Object.assign({}, mapConfig, props.config);
    this.labels = [];

    this.updateLabels = this.updateLabels.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.isMapActive !== this.state.isMapActive || nextProps.isMapVisible !== this.props.isMapVisible) {
      return true;
    }

    if (nextProps.geocoderLatLng.length && !Utils.arraysEqual(nextProps.geocoderLatLng, this.props.geocoderLatLng)) {
      this.map.setView(nextProps.geocoderLatLng, 17);
      this.props.updateState({ geocoderLatLng: [] });

      $('.home-marker').remove();

      let userMarker = L.divIcon({
        className: 'home-marker',
        html: '<div class="inner-marker"><svg class="icon icon-house"><use xlink:href="spritemap.svg#icon-house"></use></svg></div>'
      });
      L.marker(nextProps.geocoderLatLng, { icon: userMarker }).addTo(this.map);
    }

    return false;
  }

  componentDidMount() {
    const startZoom = Utils.getZoomByWindowSize();
    this.map = L.map(this.refs.map, {
      maxBounds: this.mapConfig.bounds,
      zoomControl: false,
      center: this.mapConfig.center,
      zoom: startZoom,
      minZoom: this.mapConfig.minZoom,
      maxZoom: this.mapConfig.maxZoom
    });

    disableMap(this.map);

    this.map.on('move', removeCta);
    this.map.on('zoom', () => {
      const nextZoom = this.map.getZoom();
      removeCta();
      updateZoomClass(nextZoom, this.recentZoom);

      this.recentZoom = nextZoom;
    });

    updateZoomClass(startZoom, null);
    this.recentZoom = startZoom;

    const zoomControl = !(Utils.isSmartphone || window.innerWidth < 500);

    if (zoomControl) {
      L.control.zoom({ position: 'bottomright' }).addTo(this.map);
    }

    //
    // https://interaktiv.morgenpost.de/tiles/berlin-1953-2016/2016/{z}/{x}/{y}.jpg
    // 1989 ohne labels: http://{s}.tiles.mapbox.com/v3/berlinermorgenpost.lbn2vs4i/{z}/{x}/{y}.png
    // 1989 mit labels: https://api.mapbox.com/styles/v1/berlinermorgenpost/cjcvxvezj0wqx2srz3gwvu3o9/tiles/256/{z}/{x}/{y}
    const TileLayerLeft = L.tileLayer(
      // 'https://api.maptiler.com/maps/d3ebb3b9-a50f-41c0-8dae-6bad8307fe44/256/{z}/{x}/{y}.png?key=68ErAz6zqgdV9jEjhpuz',
      '/maps/berlin-1989/{z}/{x}/{y}.jpg',
      {
        format: 'jpg70',
        attribution: this.mapConfig.attribution,
        maxZoom: this.mapConfig.maxZoom,
        minNativeZoom: 10
      }
    ).addTo(this.map);

    // codefor: 'https://tiles.codefor.de/berlin-2019/{z}/{x}/{y}.png'
    const TileLayerRight = L.tileLayer(
      // 'https://api.maptiler.com/maps/0fc51c71-96b1-40c4-9856-17adc259089b/256/{z}/{x}/{y}.png?key=68ErAz6zqgdV9jEjhpuz',
      // 'https://api.maptiler.com/maps/5eb4a145-05a1-46a9-b65f-ce28eae39497/256/{z}/{x}/{y}.png?key=68ErAz6zqgdV9jEjhpuz',
      '/maps/berlin-2019/{z}/{x}/{y}.jpg',
      {
        format: 'jpg70',
        attribution: this.mapConfig.attribution,
        maxZoom: this.mapConfig.maxZoom,
        minNativeZoom: 11
      }
    ).addTo(this.map);

    $('.lazy-map').each((i, el) => {
      const $el = $(el);
      const icon = L.divIcon({ className: 'map-marker', html: `<div class="inner-marker"><a href="#slider_${i + 1}">${i + 1}</a</div>` });
      const pointCenter = JSON.parse($el.attr('data-center'));

      const m = L.marker(pointCenter, { icon: icon }).addTo(this.map);
      m.on('click', () => {
        $([document.documentElement, document.body]).animate({
          scrollTop: $el.offset().top
      }, 600);
      })
    });

    const SlideControl = L.control.sideBySide(TileLayerLeft, TileLayerRight).addTo(this.map);

    let lastX;

    SlideControl.on('dividermove', evt => {
      if (lastX && evt.x !== lastX) {
        $('.intro').addClass('hide-help');
      }

      lastX = evt.x;
    });

    this.loadDataLayer();
    this.updateLabels();
  }

  loadDataLayer() {
    $.ajax({ url: 'data/berlin-outer.topo.json', dataType: 'json' }).done(res => {
      this.addTopoJsonLayer(res);
    });

    $.ajax({ url: 'data/mauer_grenzstreifen.topo.json', dataType: 'json'}).done(res => {
      this.borderLayer.addData(res);
      this.borderLayer.addTo(this.map);
      this.borderLayer.eachLayer(layer => {
        layer._path.classList.add('borderline');

        layer.setStyle({
          fillColor: '#00E4FF',
          fillOpacity: 0.5,
          stroke: false
        });
      });
    });
  }

  getFill(areaType) {
    return typeof areaType === 'undefined' ? '#222' : 'none';
  }

  getOpacity(areaType) {
    return typeof areaType === 'undefined' ? 1 : 0;
  }

  styleLayer(_layer) {
    _layer.eachLayer(layer => {
      layer.setStyle({
        fillColor: this.getFill(layer.feature.properties.type),
        fillOpacity: this.getOpacity(layer.feature.properties.type),
        weight: 1,
        color: '#fff',
        strokeOpacity: 1
      });
    });
  }

  updateLabels() {
    //remove old labels
    this.labels.forEach(label => {
      this.map.removeLayer(label);
    });

    this.labels = [];

    const labels = getLabelsByZoom({ language: 'de', zoom: this.map.getZoom() });

    labels.forEach(label => {
      const className = 'map-label';
      const labelIcon = L.divIcon({
        className: className,
        html: label[0]
      });

      const labelEl = L.marker([label[1], label[2]], {
        icon: labelIcon
      }).addTo(this.map);

      this.labels.push(labelEl);
    });
  }

  bindMouseEvents(_layer) {
    // this.map.on('movestart', Utils.animateHeadline);
    this.map.on('zoomend', this.updateLabels);
  }

  addTopoJsonLayer(topoJson) {
    this.topoLayer.addData(topoJson);
    this.topoLayer.addTo(this.map);

    this.bindMouseEvents(this.topoLayer);
    this.styleLayer.bind(this)(this.topoLayer);
  }

  toggleMapActive() {
    if (!this.map) {
      return false;
    }
    if (this.state.isMapActive) {
      disableMap(this.map);
    } else {
      enableMap(this.map);
    }

    const isMapActive = !this.state.isMapActive;
    this.setState({ isMapActive });
    $('html').toggleClass('is-map-active', isMapActive);
    removeCta();
  }

  render() {
    const { isMapVisible } = this.props;
    const mapToggleClasses = classnames('maptoggle btn dark', { visible: isMapVisible });
    const labelLeftClasses = classnames('label', 'left', { visible: isMapVisible });
    const labelRightClasses = classnames('label', 'right', { visible: isMapVisible });

    return (
      <div id="map-comp" ref="map">
        <div className={labelLeftClasses}>1989</div>
        <div className={labelRightClasses}>2019</div>
        <button className={mapToggleClasses} onClick={() => this.toggleMapActive()}>
          {this.state.isMapActive ? (
            <div>
              <Icon type="scroll" /> Scrollen aktivieren
            </div>
          ) : (
            <div>
              <Icon type="move" /> Karte aktivieren
            </div>
          )}
        </button>
        <div className="calltoaction" id="mapcta">
          <img src="images/slider/hand-slider.svg" />
          <span className="calltoaction-text">Verschieben</span>
        </div>
      </div>
    );
  }
}

export default Map;
